import { useConfig } from '../config/ConfigContext';
import logoSrc from '../assets/logo-light.svg';

export default function Wordmark() {
  const config = useConfig();
  return (
    <a
      href="/"
      aria-label={`${config.instance.name} — home`}
      style={{
        textDecoration: 'none',
        display: 'inline-flex',
        alignItems: 'center',
        flexShrink: 0,
      }}
    >
      <img
        src={logoSrc}
        alt="do.place"
        height={28}
        style={{ display: 'block' }}
      />
    </a>
  );
}
